import React, {ReactElement, ReactNode} from 'react';
import style from './style.module.scss';
import {Tooltip} from 'components/Tooltip';
import {Typography} from 'components/Typography';
import cs from 'classnames';

export type TLabelProps = {
    children?: ReactNode;
    id: string;
    className?: string;
    url: string | null;
    tooltip: ReactElement | null;
    tooltipClassName?: string | null;
    overlayClassName?: string | null;
};

export const Label = (props: TLabelProps) => {
    const {children, id, tooltip, overlayClassName, url = '', className = ''} = props;

    const childrenWithLink = <a href={url || ''}>{children}</a>;

    const isInteractive = Boolean(url) || Boolean(tooltip);

    if (!tooltip) {
        return (
            <div
                className={cs(style.main, className, {
                    [style.interactive]: isInteractive,
                })}
            >
                {url ? childrenWithLink : children}
            </div>
        );
    }

    return (
        <Tooltip
            childrenClassName={cs(style.main, className, {
                [style.interactive]: isInteractive,
            })}
            id={id}
            overlay={<div className={cs(style.overlay, overlayClassName)}>{tooltip}</div>}
        >
            {url ? childrenWithLink : children}
        </Tooltip>
    );
};

// оборачивает текст тултипа в Typography только если тултип реально пришёл с бэка,
// иначе Label получит непустой ReactElement и всегда будет считать себя интерактивным
export const renderLabelTooltip = (tooltip: string | null): ReactElement | null =>
    tooltip ? <Typography variant={'label-12-r'}>{tooltip}</Typography> : null;
